<template>
  <div class="series nour" id="nour" :class="{ 'darken-bg' : darkenBg }">
    <transition name="fade">
      <div v-if="loading" class="loading">
      </div>

      <div v-else class="scroll-group" id="scroll-tracking-nour">

        <Transition name="description">
          <div class="description-wrapper mobile">
            <div class="foldout-button" @click="unfold = !unfold" :class="{ 'unfold' : unfold }">
              <p class="description-meta" v-html="photoArray[descriptionId].meta"></p>
              <img v-if="!unfold" class="chevron" src="../assets/interface/chevron-up.svg"/>
              <img v-else class="chevron" src="../assets/interface/chevron-down.svg"/>
            </div>
            <p class="description-content" v-if="unfold" v-html="photoArray[descriptionId].content"></p>
            <p class="description-credits" v-if="unfold" v-html="photoArray[descriptionId].credits"></p>
          </div>
        </Transition>


        <div v-for="(group, groupIndex) in photoArray" :key="group.id" class="groups" :id="group.id">
          <Transition name="description">
            <div v-if="group.content || group.meta" class="description-wrapper desktop">
              <div class="foldout-button" @click="unfold = !unfold">
                <p class="description-meta" v-html="group.meta" @click="unfold = !unfold"></p>
                <img v-if="!unfold" class="chevron" src="../assets/interface/chevron-up.svg"/>
                <img v-else class="chevron" src="../assets/interface/chevron-down.svg"/>
              </div>
              <p class="description-content" v-if="unfold" v-html="group.content"></p>
            </div>
          </Transition>

          <div v-for="(object, index) in group.imageslist" :key="object.id" :class="{ 'first' : index === 0 && groupIndex > 0 }">
            <video v-if="object.media && object.media.match(/^.*\.(mp4)/)"
                   controls
                   class="video-container"
                   :poster="$store.state.$imageBaseURL + object.id + '/' + object.poster + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken">
              <source :src="$store.state.$fileBaseURL + object.id + '/' + object.media"/>
            </video>

            <div v-else class="img-container"
                 @mouseenter="startReflection($event)" @mouseleave="stopReflection($event)"
                 @click="showLightbox($event, object)">

              <ImageLoader class="image1"
                           :small="$store.state.$imageBaseURL + object.id + '/' + object.cover1 + '?w=16&q=50&dpr=1&token=' + $store.state.$imageToken"
                           :trueSize="$store.state.$imageBaseURL + object.id + '/' + object.cover1 + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken"/>

              <ImageLoader class="image2"
                           :small="$store.state.$imageBaseURL + object.id + '/' + object.cover2 + '?w=6&q=50&dpr=1&token=' + $store.state.$imageToken"
                           :trueSize="$store.state.$imageBaseURL + object.id + '/' + object.cover2 + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken"/>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="lightboxImage" id="image-lightbox">
      <div id="lightbox-backdrop"></div>
      <p class="buttons">
        <svg id="close" @click="lightboxImage = null"
             :style="{ opacity: lightboxImage ? '1' : '0',
                       pointerEvents: lightboxImage ? 'all' : 'none'}"
             xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="36"
             height="36" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none"
             stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </p>
      <ImageLoader id="lightbox-image"
                   :small="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.lightbox_image + '?w=8&q=50&dpr=2&token=' + $store.state.$imageToken"
                   :trueSize="$store.state.$imageBaseURL + lightboxImage.id + '/' + lightboxImage.lightbox_image + '?w=500&q=100&dpr=2&token=' + $store.state.$imageToken"/>
    </div>

  </div>
</template>

<script>
import scrollManager from '@/assets/js/scrollManager.js'
import ImageLoader from '../components/ImageLoader.vue'

export default {
  name: 'Home',
  components: {
    ImageLoader
  },
  data() {
    return {
      unfold: window.innerWidth >= 800,
      photoArray: [],
      descriptionId: 0,
      loading: true,
      lightboxImage: null,
      darkenBg: false
    }
  },
  mounted() {
    this.fetchContent();
  },
  computed: {
    sorting() {
      return this.photoArray.slice().sort((a, b) => a.sort_index - b.sort_index);
    },
    mobile() {
      return this.$store.state.$mobile;
    }
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        this.$nextTick(() => {
          let scrolltracking = document.getElementById("scroll-tracking-nour");
          let scrollparent = document.getElementById("nour");

          if (scrolltracking) {
            scrolltracking.addEventListener("wheel", (e) => {
              this.changeDescription(e);
            }, {passive: true});

            scrollparent.addEventListener("scroll", (e) => {
              this.changeDescription(e);
            }, {passive: true});

            scrolltracking.addEventListener("touchmove", (e) => {
              this.changeDescription(e);
            }, {passive: true});
          }

          if (!this.mobile) {
            const scrollableDescriptions = document.querySelectorAll('.description-wrapper.desktop');

            scrollableDescriptions.forEach(scrollable => {

              scrollable.addEventListener('wheel', function(e) {
                const { scrollTop, scrollHeight, clientHeight } = scrollable;
                const delta = e.deltaY;

                const atTop = scrollTop === 0;
                const atBottom = scrollTop + clientHeight >= scrollHeight;

                if ((atTop && delta < 0) || (atBottom && delta > 0)) {
                  return;
                }

                e.stopPropagation();
              }, { passive: false });
            });
          }

        });
      }
    }
  },
  methods: {
    showLightbox(event, object) {
      event.stopPropagation();
      this.lightboxImage = object;
    },
    changeDescription() {
      let series1 = document.getElementById("nour");
      let blocks = document.getElementsByClassName("groups");

      let i = 0;
      for (let block of blocks) {
        this.isElementVisible(block, series1, i);
        i++;
      }
    },
    isElementVisible(el, holder, i) {
      holder = holder || document.body;
      const elRect = el.getBoundingClientRect();
      const holderRect = holder.offsetWidth / 2;

      if (elRect.left <= holderRect) {
        if (this.descriptionId !== el.id) {
          this.descriptionId = i;
        }
      }
    },
    fetchContent() {
      fetch(`https://marinkagrondel.com/cms/api/entries?id=photo-series/nour&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not OK');
            } else {
              response.json()
                  .then((data) => {

                    let array = Object.values(data.data);
                    let sorted = array.slice().sort((a, b) => a.sort_index - b.sort_index);

                    for (let [i, installation] of sorted.entries()) {
                      if (installation.visibility === "visible") {
                        this.photoArray[i] = installation;
                        this.photoArray[i].imageslist = [];

                        fetch(`https://marinkagrondel.com/cms/api/entries?id=${installation.id}&options[collection]=true&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
                            .then((response) => {
                              if (!response.ok) {
                                throw new Error('Network response was not OK')
                              } else
                                response.json()
                                    .then((imageData) => {
                                      // convert Object to Array !!!
                                      let entries = Object.values(imageData.data);
                                      let sorted = entries.slice().sort((a, b) => a.sort_index - b.sort_index);
                                      this.photoArray[i].imageslist = sorted;
                                      this.$forceUpdate();

                                      let series1 = document.getElementById("nour");

                                      this.loading = false;
                                      scrollManager(series1);
                                    })
                            })
                      }
                    }
                  });
            }
          })
    },
    startReflection(e) {
      this.darkenBg = true;
      let gradientEl = document.createElement("DIV");
      gradientEl.classList.add("nour-gradient");
      e.target.appendChild(gradientEl);

      e.target.addEventListener('mousemove', (e) => {
        this.cursorPos(e, gradientEl)
      });
      e.target.style.backgroundColor = '#404040';
      gradientEl.style.opacity = 1;
    },
    stopReflection(e) {
      this.darkenBg = false;
      let gradientEl = document.getElementsByClassName("nour-gradient")[0];
      e.target.removeChild(gradientEl);
      e.target.style.backgroundColor = 'unset';
    },
    cursorPos(event, el) {
      let rect = event.target.getBoundingClientRect();
      var x = event.clientX - rect.left;
      el.style.transform = "translateX(" + (x - (rect.width / 2)) + "px)";
    }
  }
}
</script>


<style>
#nour #image-lightbox {
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 25px;
  z-index:1000;
}

#nour #image-lightbox img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#nour #lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #E0D9CC;
  opacity: 0.9;
  pointer-events: none;
  z-index: 999;
}

#nour #lightbox-image {
  z-index: 1000;
}

#nour .buttons {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
}

#nour #close {
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
  z-index: 1001;
}

video::-webkit-media-controls-panel {
  background-image: linear-gradient(transparent, transparent) !important;
}

audio::-webkit-media-controls-timeline,
video::-webkit-media-controls-timeline {
  display: none;
}

#reflection {
  position: fixed;
  z-index: 50;
  height: 90%;
  width: auto;
  pointer-events: none;
}

#reflection img {
  height: 100%;
}

.nour .img-container:last-child,
.nour .video-container:last-child {
  margin-right: calc(25vw - 20px);
}

.nour-gradient {
  position: absolute;
  top: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/reflection.png');
  background-repeat: no-repeat;
  background-size: 200% 100%;
  background-position: 50% 50%;
  z-index: 0;
  opacity: 0;
  filter: brightness(2);
  mix-blend-mode: hard-light;
}


#nour .img-container, #nour .video-container {
  height: 100%;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  flex-grow: 1;
  margin-right: 300px;
  transition: background-color 0.5s, filter 0.5s;
  transform: translate3d(0, 0, 0);
  z-index:80;
}

#nour .img-container:hover {
  background-color: #afafaf;
}


.img-container img, .video-container video {
  display: block;
  width: auto;
  height: 100%;
}

.image1, .image2 {
  top: 0px;
  left: 0px;
}

.image1 {
  position: relative;
  z-index: 5;
}

.image2 {
  position: absolute;
  z-index: 10;
}

.nour .image1 {
  opacity: 0.9;
}

.nour .image1:hover {
  opacity: 0.85;
}

.nour .image2 {
  opacity: 1;
  mix-blend-mode: lighten;
}

.icon-tabler-refresh:hover, .icon-tabler-x:hover {
  stroke: rgba(var(--border-color-rgb), 0.2);
}

@media only screen and (max-width: 800px) {

  #nour .img-container, #nour .video-container {
    height: auto;
  }

  .groups {
    margin-top: calc(45vh - 30px);
  }

  #nour .first,
  #installations .first{
    margin-left: 80px;
  }

  #nour .img-container, #nour .video-container {
    margin-right: 40px;
  }

  #nour .description-wrapper {
    margin-bottom: 0px;
    z-index: 200;
  }

  .video-container video {
    height: fit-content;
  }

  #nour .video-container {
    height: fit-content;
    max-height: 45vh;
    padding: 0;
    object-fit: contain;
  }

  .item-container {
    height: 60vh;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    justify-items: center;
  }

  .series .img-container img, .img-container video {
    width: auto !important;
    height: 45vh !important;
  }

  #nour .description-wrapper.mobile {
    padding: var(--vertical-padding) var(--horizontal-padding) var(--vertical-padding) var(--horizontal-padding);
    padding-top: 1.5rem;
    bottom: 0;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    left: 0;
    display: inline-block;
    background-image: linear-gradient(to right, rgb(218, 212, 208) 1%, rgb(218, 212, 208), #eae3c6, #eae3c6, #eae3c6);
    //background: rgba(218, 212, 208, 0.8);

    -webkit-mask-image: linear-gradient(to bottom, transparent, black 10%, black 100%);
    mask-image: linear-gradient(to bottom, transparent, black 10%, black 100%);
  }

  .description-wrapper.desktop {
    display: none;
  }

  #nour .img-container {
    margin-right: 40px;
  }
}
</style>